/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

import { FULL_ACTION_FRAGMENT } from '../fragments/FullActionFragment'

export const GET_ACTIONS = gql`
  query GetActions(
    $filters: ActionFilter
    $pagination: OffsetPaginationInput
    $order: ActionOrder
  ) {
    tenantActions(filters: $filters, pagination: $pagination, order: $order) {
      totalCount
      results {
        ...FullAction
      }
    }
  }
  ${FULL_ACTION_FRAGMENT}
`
